const loadMoreArticlesBtn = document.querySelector('#load-more-articles-btn');
const loadMoreResultsBtn = document.querySelector('#load-more-results-btn');
const context = 'test';

let showArticles = [];
const articleLimit = 6;
const articles = document.querySelectorAll('.overview__article');

let showSearchResults = [];
const searchResultLimit = 10;
const searchResults = document.querySelectorAll('.search-result');

let currentCount = 0;
let limit;
let items;
let showItems;
let loadMoreBtn;

if(loadMoreArticlesBtn || loadMoreResultsBtn) {

    setContext(loadMoreArticlesBtn || loadMoreResultsBtn)
    hideElements(items);
    loadElements();

    loadMoreBtn.addEventListener('click', loadElements);
}

function setContext(btn) {
    const context = btn == loadMoreArticlesBtn ? 'articles' : 'searchResults';
    switch (context) {
        case 'articles':
            limit = articleLimit;
            items = articles;
            showItems = showArticles;
            loadMoreBtn = btn;
            break;
        case 'searchResults':
            limit = searchResultLimit;
            items = searchResults;
            showItems = showSearchResults;
            loadMoreBtn = btn;
            break;
        default:
    }
}

function loadElements() {
    if((currentCount + limit ) < items.length) {
        currentCount += limit;
    } else {
        currentCount = items.length;
        loadMoreBtn.classList.add('--disable')
    }

    showItems = Array.from(items).slice(0, currentCount);
    displayElements(showItems);
}

function displayElements(elements) {
    [...elements].forEach((el) => {
        el.style.display = 'block';
    });
}

function hideElements(elements) {
    [...elements].forEach((el) => {
        el.style.display = 'none';
    });
}
